module.exports = __webpack_public_path__ + "static/img/head.6709767.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user/head.png
// module id = npTc
// module chunks = 66